<template>
  <div class="row border-bottom" v-if="possibleItems.list.clamping">
    <div class="col-10 text-start menu-section" @click="toggleCurrentEdit('clamping')">
      <h5>{{ $t('Menu.list.stones.group.formSetting.clamping.title') }}</h5>
      <p v-if="currentEdit != 'clamping'"></p>
    </div>
    <div class="col-2 text-end">
      <img :src="appUrl+'/img/icons/edit.svg'" class="icon open" @click="toggleCurrentEdit('clamping')"
           v-if="currentEdit != 'clamping'"/>
      <img :src="appUrl+'/img/icons/close.svg'" class="icon" @click="toggleCurrentEdit('clamping')" v-else/>
    </div>
    <template v-if="currentEdit == 'clamping'">
      <div class="col-12 clamping-wrapper">
        <div class="row">
          <div class="col-4 text-start">
            <fieldset class="input-group">
              <label>{{ $t('Menu.list.stones.group.formSetting.clamping.left') }}</label>
            </fieldset>
          </div>
          <div class="col-8 input-col">
            <div class="input-group">
              <div class="input-group">
                <input type="number" class="form-control" step="0.1" min="0" max="5"
                       v-model="clamping.top_distance"
                       @change="changeItemByVarValue('clamping_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_top_' + clamping.top_distance + '_' + clamping.top_factor)">
                <select class="input-group-text"
                        v-model="clamping.top_factor"
                        @change="changeItemByVarValue('clamping_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_top_' + clamping.top_distance + '_' + clamping.top_factor)">
                  <option value="1">{{ $t('Menu.list.stones.group.formSetting.clamping.stoneLength') }}</option>
                  <option value="0">{{ $t('Menu.list.stones.group.formSetting.clamping.mm') }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-start">
            <fieldset class="input-group">
              <label>{{ $t('Menu.list.stones.group.formSetting.clamping.right') }}</label>
            </fieldset>
          </div>
          <div class="col-8 input-col">
            <div class="input-group text-nowrap">
              <div class="input-group">
                <input type="number" class="form-control" step="0.1" min="0" max="5"
                       v-model="clamping.down_distance"
                       @change="changeItemByVarValue('clamping_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_down_' + clamping.down_distance + '_' + clamping.down_factor)">
                <select class="input-group-text"
                        v-model="clamping.down_factor"
                        @change="changeItemByVarValue('clamping_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_down_' + clamping.down_distance + '_' + clamping.down_factor)">
                  <option value="1">{{ $t('Menu.list.stones.group.formSetting.clamping.stoneLength') }}</option>
                  <option value="0">{{ $t('Menu.list.stones.group.formSetting.clamping.mm') }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-start">
            <fieldset class="input-group">
              <label>{{ $t('Menu.list.stones.group.formSetting.clamping.depth.title') }}</label>
            </fieldset>
          </div>
          <div class="col-8 input-col">
            <fieldset class="input-group depth">
              <select @change="changeClampingDepth($event);clamping.depth=$event.target.value">
                <option value="-1" :selected="clamping.depth === -1">{{ $t('Menu.list.stones.group.formSetting.clamping.depth.ring') }}</option>
                <option value="-2" :selected="clamping.depth === -2"
                        v-if="clamping.ring_type == 11 || (clamping.ring_type >= 18 && clamping.ring_type <= 29)">
                  {{ $t('Menu.list.stones.group.formSetting.clamping.depth.topDisc') }}
                </option>
                <option value="0" :selected="clamping.depth >= 0">
                  {{ $t('Menu.list.stones.group.formSetting.clamping.depth.mm') }}
                </option>
              </select>
            </fieldset>
            <fieldset class="input-group">
              <div class="input-group" v-if="clamping.depth >= 0">
                <div class="input-group">
                  <input type="number" max="50" min="0" step="0.1" v-model="clamping.depth"
                         class="form-control"
                         @change="changeItemByVarValue('clamping-depth_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_' + clamping.depth)"/>
                  <div class="input-group-addon">{{ $t('Menu.list.stones.group.formSetting.clamping.mm') }}</div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-start">
            <fieldset class="input-group">
              <label>{{ $t('Menu.list.stones.group.formSetting.clamping.width.title') }}</label>
            </fieldset>
          </div>
          <div class="col-8 input-col">
            <select v-model="clamping.width"
                    @change="changeItemByVarValue('clamping-width_' + possibleItems.groupId + '_' + possibleItems.stoneId + '_' + clamping.width)">
              <option value="0">{{ $t('Menu.list.stones.group.formSetting.clamping.width.ring') }}</option>
              <option value="-1">{{ $t('Menu.list.stones.group.formSetting.clamping.width.disc') }}</option>
            </select>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'Clamping',
    props: [
      "possibleItems",
      "currentEdit",
      "itemData",
      "stoneId",
      "groupId",
      "clamping"
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl
      }
    },
    computed: {},
    methods: {
      toggleCurrentEdit: function (id) {
        this.$parent.toggleCurrentEdit(id);
      },
      changeItemByVarValue: function (varValue) {
        this.$parent.changeItemByVarValue(varValue);
      },
      changeClampingDepth: function (event) {
        if (event.target.value < 0 && event.target.value !== this.possibleItems.list.clamping[0].depth) {
          this.changeItemByVarValue('clamping-depth_' + this.possibleItems.groupId + '_' + this.possibleItems.stoneId + '_' + event.target.value);
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    .menu-section {
      cursor: pointer;
    }

    label {
      font-weight: normal;
      line-height: 2.2em;
    }

    .clamping-wrapper {
      margin-top: 1.5rem;
    }

    .input-group {
      margin-bottom: 1rem;
    }

    select {
      width: 20rem;
      height: 4rem;
    }
  }
</style>
